import { Pipe, PipeTransform } from '@angular/core';
import { Currency } from '../../models/currency-list';

@Pipe({
  name: 'currencySymbol'
})
export class CurrencySymbolPipe implements PipeTransform {

  transform(currency: string): any {
    if (currency) {
      currency = Currency.find((item) => item.currency === currency.toUpperCase()).symbol;
    }
    return currency;
  }
}
